// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__14gWQ","detailsWrapper":"styles_detailsWrapper__1ngE2","detailsWrapperContent":"styles_detailsWrapperContent__1f0v8","details":"styles_details__1ddvK"};